/* eslint-disable react/prop-types */
import { useCallback } from 'react'
import R from 'ramda'
import { useFormikContext } from 'formik'

import { Select } from '@redriverpress/system'

import Field from './Field'

/**
 * Formik's default onChange expects an Event not just the value. Workaround that.
 * Also forms store option's value as form value.
 *
 * Take sign-up for example. It shows a country select. When the user choose a country
 * formik track the country code (option.value).
 */
function SelectControl({ onChange, ...props }) {
  const formik = useFormikContext()

  const { getOptionValue, name } = props

  const getValue = getOptionValue || R.identity

  const handleChange = useCallback(
    option => {
      const value = option ? getValue(option) : ''

      const event = { target: { name, value } }

      // Let formik know that the field changed
      formik.handleChange(event)
      // Now call onChange prop only if it's a user provided callback (formik injects onChange by default)
      if (onChange !== formik.handleChange) {
        onChange(event)
      }
    },
    [name, onChange, getValue, formik.handleChange]
  )

  return <Select onChange={handleChange} {...props} />
}

export default function SelectField(props) {
  return <Field as={SelectControl} {...props} />
}
